<template>
  <div
    class="overlay"
    @click.self="$emit('fechar')"
  >
    <div class="modal-filtros">
      <div class="modal-header">
        <span>Filtros Notícias</span>
        <button
          class="btn-fechar"
          @click="$emit('fechar')"
        >
          ✕
        </button>
      </div>

      <div class="modal-corpo">
        <div class="coluna">
          <p class="coluna-titulo">Data Inicial:</p>
          <input
            type="date"
            v-model="filtros.dataInicial"
            class="input-data"
          />
        </div>

        <div class="coluna">
          <p class="coluna-titulo">Data Final:</p>
          <input
            type="date"
            v-model="filtros.dataFinal"
            class="input-data"
          />
        </div>
      </div>

      <div class="modal-rodape">
        <button
          class="btn-limpar"
          @click="limparFiltros"
        >
          Limpar filtros
        </button>
        <button
          class="btn-filtrar"
          @click="aplicarFiltros"
        >
          Filtrar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";

const props = defineProps({
  filtrosIniciais: {
    type: Object,
    default: () => ({
      dataInicial: "",
      dataFinal: "",
    }),
  },
});

const emit = defineEmits(["fechar"]);

const router = useRouter();
const route = useRoute();

const filtros = ref({
  dataInicial:
    route.query.dataInicial || props.filtrosIniciais?.dataInicial || "",
  dataFinal: route.query.dataFinal || props.filtrosIniciais?.dataFinal || "",
});

watch(
  () => [route.query.dataInicial, route.query.dataFinal],
  ([novaInicial, novaFinal]) => {
    filtros.value.dataInicial = novaInicial || "";
    filtros.value.dataFinal = novaFinal || "";
  }
);

function limparFiltros() {
  const query = { ...route.query };
  delete query.dataInicial;
  delete query.dataFinal;
  delete query.page;

  filtros.value = { dataInicial: "", dataFinal: "" };

  router.push({ query });
  emit("fechar");
}

function aplicarFiltros() {
  const query = { ...route.query };

  if (filtros.value.dataInicial) {
    query.dataInicial = filtros.value.dataInicial;
  } else {
    delete query.dataInicial;
  }

  if (filtros.value.dataFinal) {
    query.dataFinal = filtros.value.dataFinal;
  } else {
    delete query.dataFinal;
  }

  delete query.page;

  router.push({ query });
  emit("fechar");
}
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-filtros {
  background: var(--branco);
  border-radius: 12px;
  width: auto;
  min-width: 580px;
  max-width: 95vw;
  overflow: hidden;
  box-shadow: 0 8px 32px var(--preto);
}

.modal-header {
  background: var(--roxo-escuro2);
  color: var(--branco);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px 20px;
  font-size: 1rem;
  font-weight: 600;
  position: relative;
}

.btn-fechar {
  position: absolute;
  right: 14px;
  background: transparent;
  border: 2px solid var(--branco);
  color: var(--branco);
  border-radius: 6px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-corpo {
  display: flex;
  justify-content: space-around;
  padding: 30px 20px;
  background: var(--branco);
  gap: 16px;
}

.coluna {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.coluna-titulo {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--preto);
}

.input-data,
.select-unidade {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 0.9rem;
  outline: none;
  width: 100%;
  background: white;
}

.select-unidade {
  padding-right: 32px;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23563578' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.input-data:focus,
.select-unidade:focus {
  border-color: var(--roxo-claro);
}

.modal-rodape {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 20px;
  background: var(--branco);
}

.btn-limpar {
  border: 2px solid var(--roxo-claro);
  background: var(--branco);
  color: var(--roxo-claro);
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-filtrar {
  background: var(--roxo-claro);
  color: var(--branco);
  border: none;
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
}
</style>
